// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { Resources } from '@shared/localizations/Resources';
import { QuickTableCell } from './QuickTableCell';
import { QuickTableRow } from './QuickTableRow';
export class QuickTableGroupRow extends QuickTableRow {
    constructor(table) {
        super(null, table);
        this.isGroupRow = true;
        this.collapsed = false;
        this.GroupValue = '';
        this.infoIconTooltip = ''; // draw (if it is not empty string) info icon with tooltip text = infoIconTooltip
        this.groupStr = '';
        this.isDirty = true;
        const columnsCount = table.columns.length;
        const cells = [];
        for (let i = 0; i < columnsCount; i++) {
            cells.push(new QuickTableCell());
        }
        this.cells = cells;
        this.localize();
    }
    localize() {
        this.groupStr = Resources.getResource(this.GroupValue);
        this.isDirty = true;
    }
}
